import React from 'react';
import { Input } from 'reactstrap';

export interface TermsFormSelectProps {
    value: string;
    options: readonly string[];
    onChange: (value: string | null) => void;
    disabled?: boolean;
    invalid?: boolean;
    'aria-label': string;
}

export const TermsFormSelect: React.FC<TermsFormSelectProps> = ({
    value,
    options,
    onChange,
    disabled,
    invalid,
    'aria-label': ariaLabel,
}) => (
    <Input
        type="select"
        value={value}
        disabled={disabled}
        invalid={invalid}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
        className="form-control loi-form-input"
        aria-label={ariaLabel}>
        <option value="" />
        {options.map((opt) => (
            <option key={opt} value={opt}>
                {opt}
            </option>
        ))}
    </Input>
);
